var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_302)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2.625C7.7224 2.625 2.625 7.7224 2.625 14C2.625 20.2776 7.7224 25.375 14 25.375C20.2776 25.375 25.375 20.2776 25.375 14C25.375 7.7224 20.2776 2.625 14 2.625ZM14 4.375C19.3116 4.375 23.625 8.6884 23.625 14C23.625 19.3116 19.3116 23.625 14 23.625C8.6884 23.625 4.375 19.3116 4.375 14C4.375 8.6884 8.6884 4.375 14 4.375Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 18.375C16.4162 18.375 18.375 16.4162 18.375 14C18.375 11.5838 16.4162 9.625 14 9.625C11.5838 9.625 9.625 11.5838 9.625 14C9.625 16.4162 11.5838 18.375 14 18.375Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 0.86192V6.11105C13.125 6.59397 13.517 6.98615 14 6.98615C14.483 6.98615 14.875 6.59397 14.875 6.11105V0.86192C14.875 0.379001 14.483 -0.0131836 14 -0.0131836C13.517 -0.0131836 13.125 0.379001 13.125 0.86192Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1381 13.125H21.889C21.406 13.125 21.0139 13.517 21.0139 14C21.0139 14.483 21.406 14.875 21.889 14.875H27.1381C27.621 14.875 28.0132 14.483 28.0132 14C28.0132 13.517 27.621 13.125 27.1381 13.125Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.125 24.5393V27.1669C13.125 27.6504 13.517 28.0427 14 28.0427C14.483 28.0427 14.875 27.6504 14.875 27.1669V24.5393C14.875 24.0558 14.483 23.6636 14 23.6636C13.517 23.6636 13.125 24.0558 13.125 24.5393Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13808 13.125H0.888955C0.406035 13.125 0.0138507 13.517 0.0138507 14C0.0138507 14.483 0.406035 14.875 0.888955 14.875H6.13808C6.621 14.875 7.01318 14.483 7.01318 14C7.01318 13.517 6.621 13.125 6.13808 13.125Z",
    fill: "#2A323F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10045 22.442C7.04358 22.7745 7.18271 23.1105 7.45921 23.3048C9.30983 24.6094 11.5665 25.375 13.9998 25.375C16.4341 25.375 18.6907 24.6085 20.5413 23.3048C20.817 23.1105 20.957 22.7745 20.9001 22.442C20.3375 19.1397 17.4622 16.625 13.9998 16.625H13.9981C12.1422 16.625 10.3616 17.3626 9.04996 18.6751C8.01921 19.705 7.34283 21.0245 7.10045 22.442Z",
    fill: "#2A323F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2);
export default __webpack_public_path__ + "static/media/v2.da33757f9618fb3ca7f51f4e32e4774a.svg";
export { ForwardRef as ReactComponent };